<div class="titles-wrapper">
  <div class="title-container">
    <div class="selector-div-wrapper">
      <p><small>Mostrar</small></p>
      <!-- <div class="selector-div">
          <select name="selector" class="selector" [(ngModel)]="tool.enabled">
            <option [ngValue]="true">Si</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="vertical-line"></div>
        </div> -->
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="searcher-switch"
          [(ngModel)]="tool.enabled" [checked]="tool.enabled" />
      </div>
    </div>
  </div>

  <div *ngIf="tool.enabled">
    <div class="searcher-container">
      <span>Tipo de buscador</span>
      <div class="type-button-container">
        <button class="type-button" (click)="tool.type = 'text'" [ngClass]="{ active: tool.type === 'text' }">
          <img src="/assets/img/tools/searcher/libre.svg" alt="" />Texto libre
        </button>
        <button class="type-button" (click)="tool.type = 'splitted'" [ngClass]="{ active: tool.type === 'splitted' }">
          <img src="/assets/img/tools/searcher/asiento.svg" alt="" />Sector Fila
          Asiento
        </button>
      </div>
    </div>
    
    <div class="selector-div-wrapper" *ngIf="tool.type === 'splitted'">
      <span>Orden</span>
      <div class="selector-div">
        <select name="selector" class="selector" [(ngModel)]="tool.order">
          <option [selected]="tool.order === 'json'" [ngValue]="'json'">Json</option>
          <option [selected]="tool.order === 'alphabetical'" [ngValue]="'alphabetical'">Alfabético</option>
        </select>
        <div class="vertical-line"></div>
      </div>
    </div>

    <div class="upload-file-container mb-3" *ngIf="tool.type === 'splitted' && workflow.id !== 3 && workflow.id !== 4">
      <div class="file-content" *ngIf="!postedFile; else fileExisting" fileDropZone (fileDrop)="onFileDropped($event)">
        <p class="text-drag-file">Arrastrar el archivo aquí</p>
        <p class="text-drag-file divisor">— o —</p>
        <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
        <button class="upload-file-btn" (click)="fileUpload.click()">
          Seleccionar archivo de tu ordenador
        </button>
      </div>
      <a class="btn-transparent" [href]="downloadTemplate" download="search_template.json">Descargar plantilla</a>

      <ng-template #fileExisting>
        <div class="file-content active">
          <div class="file-box">
            <span>{{ postedFile.name }}</span>
            <button class="element-action-btn" (click)="deleteDroppedFile()">
              <img id="delete" alt="" />
            </button>
          </div>
          <div class="jsonviewer-wrapper" *ngIf="tool.fileData">
            <ngx-json-viewer *ngIf="tool.fileData" [json]="tool.fileData" [expanded]="false"></ngx-json-viewer>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="wrapper-bottom">
    <button class="btn-secondary-action" (click)="apply()">
      Aplicar cambios
    </button>
  </div>
</div>